export const EXIT_INTENT_KEY = 'showExitIntentModal';
